import { render, staticRenderFns } from "./GiftCardIndex.vue?vue&type=template&id=57c053fe&scoped=true"
import script from "./GiftCardIndex.vue?vue&type=script&lang=js"
export * from "./GiftCardIndex.vue?vue&type=script&lang=js"
import style1 from "./GiftCardIndex.vue?vue&type=style&index=1&id=57c053fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c053fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c053fe')) {
      api.createRecord('57c053fe', component.options)
    } else {
      api.reload('57c053fe', component.options)
    }
    module.hot.accept("./GiftCardIndex.vue?vue&type=template&id=57c053fe&scoped=true", function () {
      api.rerender('57c053fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardIndex.vue"
export default component.exports